import { defaultTo, ifElse, pipe } from 'rambda';
import { isFilled } from './isFilled';

export const defaultNAValue = '-/-';
export const defaultToNA = defaultTo<string | number>(defaultNAValue);

export const mapToOrDefaultNA = <T>(
  mapFn: (x: T) => string | number | undefined,
) => ifElse(isFilled, pipe(mapFn, defaultToNA), defaultTo);
